// src/containers/FavoritesPage/FavoritesPage.duck.js

import { fetchCurrentUser } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { resultIds } from '../SearchPage/SearchPage.duck';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getFavorites } from '../../util/genericHelpers';



// ——— Action‐type constants —————————————————————————————
const LOAD_FAVORITES_REQUEST = 'app/FavoritesPage/LOAD_FAVORITES_REQUEST';
const LOAD_FAVORITES_SUCCESS = 'app/FavoritesPage/LOAD_FAVORITES_SUCCESS';
const LOAD_FAVORITES_ERROR = 'app/FavoritesPage/LOAD_FAVORITES_ERROR';
export const SEARCH_FAVORITES_SUCCESS = 'app/FavoritesPage/SEARCH_FAVORITES_SUCCESS';

// ——— Initial state & reducer ——————————————————————————————
const initialState = { items: [], isLoading: false, error: null };

export default function favoritesReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_FAVORITES_REQUEST:
      return { ...state, isLoading: true, error: null };

    case LOAD_FAVORITES_SUCCESS:
      return { ...state, isLoading: false, items: payload };

    case LOAD_FAVORITES_ERROR:
      return { ...state, isLoading: false, error: payload };

    case SEARCH_FAVORITES_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        searchInProgress: false,
      };

    default:
      return state;
  }
}

// ——— Action creators ——————————————————————————————
export const loadFavoritesRequest = () => ({ type: LOAD_FAVORITES_REQUEST });
export const loadFavoritesSuccess = items => ({
  type: LOAD_FAVORITES_SUCCESS,
  payload: items,
});
export const loadFavoritesError = e => ({
  type: LOAD_FAVORITES_ERROR,
  payload: storableError(e),
  error: true,
});
export const searchFavoritesSuccess = response => ({
  type: SEARCH_FAVORITES_SUCCESS,
  payload: { data: response.data },
});

export const searchFavorites = (config) => async (dispatch, getState, sdk) => {
  await dispatch(fetchCurrentUser());
  const currentUser = getState().user.currentUser;
  const favoriteIds = getFavorites(currentUser);
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const response = await sdk.listings.query(
    { ids: favoriteIds.join(','), include: ['author', 'images'] ,
    
      'fields.listing': [
        'title',
        'geolocation',
        'price',
        'deleted',
        'state',
        'publicData',
      ],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium',
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
      ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      }, );
   

  const listingFields = config?.listing?.listingFields;
  const sanitizeConfig = { listingFields };
  dispatch(addMarketplaceEntities(response, sanitizeConfig));
  dispatch(searchFavoritesSuccess(response));
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) =>
  dispatch(searchFavorites(config));
